// Meldung für einen fehlgeschlagenen Upload. Bei 429 (zu viele offene Aufträge
// oder Stundenlimit) soll klar sein, dass Warten reicht.
export function uploadFehlermeldung(err, dateiname) {
  if (err?.response?.status === 429) {
    const backend = err.response.data?.error;
    const grund =
      typeof backend === 'string' && backend
        ? backend
        : 'Zu viele Uploads in kurzer Zeit – bitte später noch einmal versuchen.';
    return `Upload von "${dateiname}" gerade nicht möglich: ${grund}`;
  }
  return `Upload von "${dateiname}" fehlgeschlagen.`;
}

// Nach einem 429 scheitern auch die weiteren Dateien (Warteschlange voll oder
// Stundenlimit). Rückgabe null: weitermachen. Sonst aufhören; der Text sagt,
// was mit den übrigen Dateien ist (leer, wenn keine mehr kommen).
export function hinweisUebrigeDateien(err, uebrige) {
  if (err?.response?.status !== 429) return null;
  if (uebrige === 0) return '';
  return uebrige === 1
    ? '1 weitere Datei wurde noch nicht hochgeladen. Sie bleibt in der Liste – stelle sie später einfach noch einmal in die Warteschlange.'
    : `${uebrige} weitere Dateien wurden noch nicht hochgeladen. Sie bleiben in der Liste – stelle sie später einfach noch einmal in die Warteschlange.`;
}
